export const createNativeAudioWorkletNodeConstructor = (window) => {
    if (window === null) {
        return null;
    }
    return (window.hasOwnProperty('AudioWorkletNode')) ? window.AudioWorkletNode : null;
};
//# sourceMappingURL=/build/es2018/factories/native-audio-worklet-node-constructor.js.map